import React from 'react'

export const TableUnstyled = ({ children, ...otherProps }) => (
  <table {...otherProps}>{children}</table>
)
